import { objectId } from '@/shared/validations/custom.validation';
import Joi from 'joi';

export const getUnitJobsByProjectId = {
  params: Joi.object().keys({
    projectId: Joi.string().required().custom(objectId),
  }),
  query: Joi.object().keys({
    status: Joi.string(),
    createdBy: Joi.string().custom(objectId),
    jobId: Joi.string(),
    sortBy: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    populate: Joi.string(),
    includeTimeStamps: Joi.boolean(),
    fields: Joi.string(),
  }),
};
